import React from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Chip,
  Button,
} from '@mui/material'
import ApartmentIcon from '@mui/icons-material/Apartment'
import AddIcon from '@mui/icons-material/Add'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../components/layout/AppShell'
import StatusBadge from '../components/ui/StatusBadge'

const KNOWN_MANAGEMENT_TYPES = ['weg', 'mv', 'sev', 'privat']

export default function Dashboard({ tenant = {}, properties = [] }) {
  const { props } = usePage()
  const tenantSlug = tenant.slug || props.tenant?.slug || ''

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Dashboard
          </Typography>
          {tenant.name && (
            <Typography variant="body1" color="text.secondary">
              {tenant.name}
            </Typography>
          )}
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => router.visit(`/m/${tenantSlug}/properties/new`)}
        >
          Neue Immobilie
        </Button>
      </Box>

      <Typography variant="h6" sx={{ mb: 2 }}>
        Immobilien
      </Typography>

      {properties.length === 0 ? (
        <Card variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <ApartmentIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Noch keine Immobilien angelegt.
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => router.visit(`/m/${tenantSlug}/properties/new`)}
            sx={{ mt: 1 }}
          >
            Erste Immobilie anlegen
          </Button>
        </Card>
      ) : (
        <Grid container spacing={2}>
          {properties.map((property) => (
            <Grid item xs={12} sm={6} md={4} key={property.id}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardActionArea
                  sx={{ height: '100%' }}
                  onClick={() => router.visit(`/m/${tenantSlug}/properties/${property.id}`)}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      {KNOWN_MANAGEMENT_TYPES.includes(property.management_type) ? (
                        <StatusBadge type="management_type" value={property.management_type} />
                      ) : (
                        <Chip size="small" label={property.management_type} />
                      )}
                      <Typography variant="caption" color="text.secondary">
                        {property.reference}
                      </Typography>
                    </Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {property.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {property.unit_count} {property.unit_count === 1 ? 'Einheit' : 'Einheiten'}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  )
}

Dashboard.layout = (page) => <AppShell>{page}</AppShell>
